import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="login-overlay">

      <!-- Change Password Modal -->
      <div class="login-card" *ngIf="showChangePassword">
        <h2 class="login-title">Changement de mot de passe requis</h2>
        <p class="login-subtitle">Veuillez définir un nouveau mot de passe pour {{ email }}</p>

        <form (ngSubmit)="handleChangePassword()" class="login-form">
          <div class="form-group">
            <label for="new-password">Nouveau mot de passe</label>
            <input id="new-password" type="password" [(ngModel)]="newPassword"
              name="newPassword" required class="form-input" />
          </div>
          <div class="form-group">
            <label for="confirm-password">Confirmer le mot de passe</label>
            <input id="confirm-password" type="password" [(ngModel)]="confirmPassword"
              name="confirmPassword" required class="form-input" />
          </div>
          <div class="error-message" *ngIf="error">{{ error }}</div>
          <button type="submit" [disabled]="isLoading" class="login-btn">
            {{ isLoading ? 'Changement...' : 'Changer le mot de passe' }}
          </button>
        </form>
      </div>

      <!-- Login Modal -->
      <div class="login-card" *ngIf="!showChangePassword">
        <div class="login-header">
          <span class="brand-mark">📋</span>
          <img src="images/Rio-Tinto-Symbol.png" alt="Rio Tinto" class="rio-logo">
          <h2 class="login-title">Index des livrables</h2>
        </div>
        <p class="login-subtitle">Connectez-vous à votre compte</p>

        <form (ngSubmit)="handleLogin()" class="login-form">
          <div class="form-group">
            <label for="login-email">Courriel</label>
            <input id="login-email" type="email" [(ngModel)]="email"
              name="email" required class="form-input"
              placeholder="prenom.nom@riotinto.com" />
          </div>
          <div class="form-group">
            <label for="login-password">Mot de passe</label>
            <input id="login-password" type="password" [(ngModel)]="password"
              name="password" required class="form-input" />
          </div>
          <div class="error-message" *ngIf="error">{{ error }}</div>
          <button type="submit" [disabled]="isLoading" class="login-btn">
            {{ isLoading ? 'Connexion...' : 'Se connecter' }}
          </button>
        </form>
      </div>

    </div>
  `,
  styles: [`
    .login-header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 8px;
      justify-content: center;
    }
    .brand-mark { display: none; }
    .rio-logo { width: 140px; height: auto; }
  `]
})
export class LoginComponent {
  email = '';
  password = '';
  newPassword = '';
  confirmPassword = '';
  error = '';
  isLoading = false;
  showChangePassword = false;

  constructor(private authService: AuthService) {}

  async handleLogin(): Promise<void> {
    this.error = '';
    this.isLoading = true;
    try {
      const result = await this.authService.login(this.email, this.password);
      if (result.requiresPasswordChange) {
        this.showChangePassword = true;
      }
    } catch (err: any) {
      this.error = err.message || 'Échec de la connexion';
    } finally {
      this.isLoading = false;
    }
  }

  async handleChangePassword(): Promise<void> {
    this.error = '';
    if (this.newPassword !== this.confirmPassword) {
      this.error = 'Les mots de passe ne correspondent pas';
      return;
    }
    if (this.newPassword.length < 8) {
      this.error = 'Le mot de passe doit contenir au moins 8 caractères';
      return;
    }
    this.isLoading = true;
    try {
      await this.authService.confirmNewPassword(this.newPassword);
    } catch (err: any) {
      this.error = err.message || 'Échec du changement de mot de passe';
    } finally {
      this.isLoading = false;
    }
  }
}
